import React, { ReactElement, useState } from 'react';

import { Page } from '@constants/enum';

import PageIndexContext from './PageIndexContext';

function PageIndexProvider({ children }: { children: ReactElement }): ReactElement {
  const [pageIndex, setPageIndex] = useState(Page.Init);

  return (
    <PageIndexContext.Provider
      value={{
        pageIndex,
        setPageIndex,
      }}
    >
      {children}
    </PageIndexContext.Provider>
  );
}
export default PageIndexProvider;
